import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

export const getSubscriptionPlans = createAsyncThunk(
  "subscription/getPlans",
  async ({ type, token }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Subscription.Subscription_Plan}?type=${type}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const purchaseSubscription = createAsyncThunk(
  "subscription/purchase",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Subscription.Buy_Subscription, data);

      if (res?.success === false) {
        return rejectWithValue(res);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: error.message },
      );
    }
  },
);

export const UserWalletHistory = createAsyncThunk(
  "/get-subscriptionHistory",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Subscription.UserWalletHistory);

      return res?.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const subscriptionSlice = createSlice({
  name: "subscriptions",
  initialState: {
    plans: [],
    history: [],
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getSubscriptionPlans.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getSubscriptionPlans.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.plans = action.payload?.data || [];
      })
      .addCase(getSubscriptionPlans.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message;
      })

      .addCase(purchaseSubscription.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
        state.error = null;
      })
      .addCase(purchaseSubscription.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(purchaseSubscription.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload?.message || "Subscription failed";
      })

      .addCase(UserWalletHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UserWalletHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.history = action.payload;
      })
      .addCase(UserWalletHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default subscriptionSlice.reducer;
